import { ApiLocalStorage } from 'utils/ApiLocalStorage';

export const createUserData = (
  schemaId: string,
  registrationData: any,
  username: string,
  termsData: any
) => {
  const sanitizePhoneFields = (data: any) => {
    const sanitizedData: any = {...data};
    
    Object.keys(sanitizedData).forEach((key) => {
      if (key.toLowerCase().includes('phone')) {
        sanitizedData[key] = sanitizedData[key]?.replace(/\D/g, '');
      }
    });
    
    return sanitizedData;
  };
  
  const addressInfo = {
    ...registrationData.addressInfo
  };
  
  if (
    ['street', 'number', 'city', 'state', 'zipCode'].every(
      (field) => registrationData.addressInfo?.[field]
    ) &&
    !registrationData.addressInfo?.address_reference
  ) {
    addressInfo.address_reference = 'Sem Ref';
  }
  
  const sanitizedContactInfo = sanitizePhoneFields(registrationData.contactInfo);
  
  const schemaData = ApiLocalStorage.get('schema');
  const isCloseSchema = schemaData?.signupType?.toLowerCase() === 'closed';
  
  const userData = {
    ...registrationData.additionalInfo,
    ...addressInfo,
    ...sanitizedContactInfo,
    ...registrationData.personalInfo,
    username,
    ...(isCloseSchema && {onboardingFinished: true})
  };
  
  return {
    schemaId,
    userData,
    terms: termsData,
    deviceData: {
      ip: '192.168.1.1',
      geolocation: {
        latitude: ApiLocalStorage.get('lt') || '',
        longitude: ApiLocalStorage.get('lg') || ''
      },
      userAgent: {
        browser: navigator.userAgent,
        browserVersion: '',
        operationalSystem: navigator.platform,
        device: '',
        deviceType: '',
        language: navigator.language
      }
    }
  };
};
